/* Military Shop – Probă virtuală (AI) pe pagina de produs. Config: window.MSTRY = { api, handle, title, type, img } */
(function () {
  'use strict';
  var C = window.MSTRY;
  if (!C || !C.api || window.MSTryOn) return;
  window.MSTSizeDone = false; // msd-pv.js așteaptă butonul de mărime înainte să afișeze pagina (fără salturi)

  var KINDS = {
    feet: /bocanc|gheat|ghete|pantof|sandal|adidas|încălțăm|incaltam|cizm|sneaker|sabo|papuc|șlap|slap|baschet|bascheț|teniș|tenisi|mocasin|botin|espadril/,
    head: /șapc|sapc|căciul|caciul|cagul|beret|bonet|pălări|palari|bandan|boonie|cască|casca /,
    eyes: /ochelari/, hands: /mănuș|manus/,
    legs: /pantalon|blugi|șort|short|bermud|colanț|colant/,
    bag: /rucsac|ghiozdan|geant|borset/,
    vest: /vest|port-arm|portarm|chest rig|plate carrier/,
    body: /combinezon|uniform|costum|salopet/,
    top: /geac|jachet|hanorac|tricou|bluz|cămaș|camas|polar|parka|softshell|pulover|helanc|cardigan|poncho|pelerin|mantă|manta|maieu|maiou|maiour|tank top|singlet|top /
  };
  var hay = (C.title + ' ' + (C.type || '')).toLowerCase(), kind = null;
  for (var k in KINDS) if (KINDS[k].test(hay)) { kind = k; break; }
  if (!kind) { window.MSTSizeDone = true; return; }

  var TIPS = {
    feet: 'Fă o poză cu tot corpul, din față, să ți se vadă picioarele.',
    head: 'Fă o poză din față, de la umeri în sus, cu fața bine luminată.',
    eyes: 'Fă o poză din față, cu fața bine luminată.',
    hands: 'Fă o poză în care să ți se vadă mâinile.',
    legs: 'Fă o poză cu tot corpul, din față, stând drept.',
    bag: 'Fă o poză de la genunchi în sus, puțin din lateral.',
    vest: 'Fă o poză de la genunchi în sus, din față.',
    body: 'Fă o poză cu tot corpul, din față, stând drept.',
    top: 'Fă o poză de la genunchi în sus, din față, stând drept.'
  };
  var LS = 'msf_g';
  function devId() {
    var g; try { g = localStorage.getItem(LS); } catch (e) {}
    if (!/^[a-f0-9]{32}$/.test(g || '')) {
      var b = new Uint8Array(16); crypto.getRandomValues(b);
      g = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
      try { localStorage.setItem(LS, g); } catch (e) {}
    }
    return g;
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pvForms() {
    return [].filter.call(document.querySelectorAll('.product-information form[action*="/cart/add"]'), function (f) {
      return !f.classList.contains('installment') && f.querySelector('[name="id"]') && (f.querySelector('[name="add"]') || f.querySelector('[name="product-id"]'));
    });
  }
  // formularul principal de cumpărare (nu cel de rate) – aici ajung proprietățile ascunse
  function pvForm() { var b = document.querySelector('.product-details .add-to-cart-button'); return (b && b.form) || pvForms()[0] || null; }
  // proprietățile ascunse (_proba_virtuala, _marime_recomandata) se țin minte în sesiune și se pun din nou
  // pe formular chiar înainte de „Adaugă în coș” (tema redesenează formularul la schimbarea mărimii)
  var PROPS = {};
  try { PROPS = JSON.parse(sessionStorage.getItem('mst_props_' + C.handle) || '{}') || {}; } catch (e) {}
  function applyProps() { for (var k in PROPS) writeProp(k, PROPS[k]); }
  function setProp(name, val) {
    PROPS[name] = val;
    try { sessionStorage.setItem('mst_props_' + C.handle, JSON.stringify(PROPS)); } catch (e) {}
    writeProp(name, val);
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.product-details .add-to-cart-button, .sticky-add-to-cart__button');
    if (t) applyProps();
  }, true);
  document.addEventListener('submit', function (e) { if (e.target && e.target.closest && e.target.closest('.product-information')) applyProps(); }, true);
  setTimeout(applyProps, 1500);
  function writeProp(name, val) {
    pvForms().forEach(function (f) {
      var i = f.querySelector('[name="properties[' + name + ']"]');
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + name + ']'; f.appendChild(i); }
      i.value = val;
    });
  }
  function variantId() { var f = pvForm(), i = f && f.querySelector('[name="id"]'); return i ? i.value : ''; }

  var ICO = {
    cam: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.6"/></svg>',
    img: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.8"/><path d="M21 16l-5-5-9 9"/></svg>',
    spark: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    share: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12M7 8l5-5 5 5M5 13v7h14v-7"/></svg>'
  };

  // ─── buton pe pagina de produs ───
  function mountButton() {
    if (document.querySelector('.mst-open')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(); });
    // pe poza principală a produsului (colțul din stânga-jos)
    var gal = document.querySelector('media-gallery');
    if (gal) {
      b.className = 'mst-open mst-open--img';
      // la remontare (Horizon reface galeria la fiecare mărime) fără animația de strălucire, ca să nu pară că se reîncarcă
      if (mountButton.done) b.classList.add('mst-noanim');
      mountButton.done = true;
      b.innerHTML = ICO.spark + '<span>Probează online</span>' + ICO.cam;
      gal.appendChild(b);
      return;
    }
    var anchor = document.querySelector('.product-details .buy-buttons-block') || pvForm();
    if (!anchor) return;
    b.className = 'mst-open';
    b.innerHTML = ICO.spark + '<span><b>Probează virtual</b><small>Vezi cum îți stă, din poza ta</small></span>' + ICO.cam;
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
  }

  // ─── fereastra ───
  var el, file = null, fileURL = '', resultURL = '', busy = false, msgT;
  function build() {
    el = document.createElement('div');
    el.className = 'mst'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Probează virtual');
    el.innerHTML =
      '<div class="mst__bg" data-x></div><div class="mst__sheet">' +
      '<button type="button" class="mst__close" data-x aria-label="Închide">' + ICO.x + '</button>' +
      '<div class="mst__head">' + (C.img ? '<img src="' + esc(C.img) + '" alt="" width="52" height="52">' : '') +
      '<div><span class="mst__eyebrow">' + ICO.spark + ' Probă virtuală AI</span><b>' + esc(C.title) + '</b></div></div>' +
      '<div class="mst__body" data-body></div></div>' +
      '<input type="file" accept="image/*" capture="user" hidden data-cam><input type="file" accept="image/*" hidden data-gal>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target.closest('[data-x]') && !busy) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-on') && !busy) close(); });
    el.querySelector('[data-cam]').addEventListener('change', onFile);
    el.querySelector('[data-gal]').addEventListener('change', onFile);
  }
  function body(html) { el.querySelector('[data-body]').innerHTML = html; }
  function open() {
    if (!el) build();
    mode = 'try';
    el.classList.add('is-on'); document.documentElement.classList.add('mst-lock'); track('open');
    if (resultURL) showResult(); else if (file) showPreview(); else showIntro();
    fetch(C.api + '?action=status&d=' + devId(), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (s) {
      var n = el.querySelector('[data-left]'); if (n && s && s.ok) n.textContent = s.remaining > 0 ? 'Mai ai ' + s.remaining + (s.remaining === 1 ? ' probă' : ' probe') + ' azi.' : 'Ai folosit toate probele de azi.';
    }).catch(function () {});
  }
  function close() { el.classList.remove('is-on'); document.documentElement.classList.remove('mst-lock'); }

  function showIntro(err) {
    body(
      (err ? '<p class="mst__err">' + esc(err) + '</p>' : '') +
      '<p class="mst__lead">Încarcă o poză cu tine și îți arătăm cum arăți purtând produsul.</p>' +
      '<ul class="mst__tips"><li>' + esc(TIPS[kind]) + '</li><li>Lumină bună, fundal simplu, o singură persoană în poză.</li></ul>' +
      '<div class="mst__pick"><button type="button" class="mst__btn mst__btn--pri" data-pick="cam">' + ICO.cam + 'Fă o poză</button>' +
      '<button type="button" class="mst__btn" data-pick="gal">' + ICO.img + 'Alege din galerie</button></div>' +
      '<p class="mst__fine">Imaginea e generată cu AI. Poza ta e folosită doar pentru probă și nu o păstrăm. <span data-left></span></p>');
    el.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () { var i = el.querySelector(b.getAttribute('data-pick') === 'cam' ? '[data-cam]' : '[data-gal]'); i.value = ''; i.click(); });
    });
  }
  function onFile(e) {
    var f = e.target.files && e.target.files[0]; if (!f) return;
    if (!/^image\//.test(f.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(f.name)) { showIntro('Alege o poză (JPG sau PNG).'); return; }
    shrink(f).then(function (blob) {
      file = blob; if (fileURL) URL.revokeObjectURL(fileURL); fileURL = URL.createObjectURL(blob);
      resultURL = ''; showPreview();
    }).catch(function () { showIntro('Nu am putut citi poza. Încearcă altă poză (JPG sau PNG).'); });
  }
  // micșorează la max. 1280px (rotația corectă din EXIF), JPEG ~85%
  function shrink(f) {
    var load = window.createImageBitmap
      ? createImageBitmap(f, { imageOrientation: 'from-image' })
      : new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = URL.createObjectURL(f); });
    return load.then(function (img) {
      var w = img.width, h = img.height, m = 1280, s = Math.min(1, m / Math.max(w, h));
      var c = document.createElement('canvas'); c.width = Math.round(w * s); c.height = Math.round(h * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      return new Promise(function (res, rej) { c.toBlob(function (b) { b ? res(b) : rej(); }, 'image/jpeg', 0.86); });
    });
  }
  function showPreview() {
    body('<div class="mst__photo"><img src="' + fileURL + '" alt="Poza ta"></div>' +
      '<div class="mst__pick"><button type="button" class="mst__btn mst__btn--pri" data-go>' + ICO.spark + 'Probează acum</button>' +
      '<button type="button" class="mst__btn" data-again>Altă poză</button></div>' +
      '<p class="mst__fine">' + esc(TIPS[kind]) + ' <span data-left></span></p>');
    el.querySelector('[data-go]').addEventListener('click', run);
    el.querySelector('[data-again]').addEventListener('click', function () { file = null; showIntro(); });
  }
  var MSG = ['Analizăm poza…', 'Pregătim produsul…', 'Potrivim croiala…', 'Ajustăm lumina și umbrele…', 'Încă puțin…', 'Aproape gata…'];
  function run() {
    if (busy || !file) return; busy = true;
    body('<div class="mst__photo mst__photo--scan"><img src="' + fileURL + '" alt=""><i class="mst__scan"></i></div>' +
      '<p class="mst__status" data-msg>' + MSG[0] + '</p><p class="mst__fine">Durează de obicei 10–25 de secunde.</p>');
    var i = 0; clearInterval(msgT);
    msgT = setInterval(function () { i = Math.min(i + 1, MSG.length - 1); var m = el.querySelector('[data-msg]'); if (m) m.textContent = MSG[i]; }, 4500);
    var fd = new FormData();
    fd.append('action', 'try'); fd.append('handle', C.handle); fd.append('variant', variantId()); fd.append('d', devId());
    fd.append('photo', file, 'poza.jpg');
    fetch(C.api, { method: 'POST', body: fd, credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (r) {
        if (r && r.ok && r.image) { resultURL = r.image; markForm(); showResult(r.remaining); track('ok'); }
        else { showIntroAfter(r && r.error); track('fail'); }
      })
      .catch(function () { showIntroAfter('Conexiunea s-a întrerupt. Încearcă din nou.'); })
      .then(function () { busy = false; clearInterval(msgT); });
  }
  function showIntroAfter(err) { if (file) { showPreview(); var b = el.querySelector('[data-body]'); b.insertAdjacentHTML('afterbegin', '<p class="mst__err">' + esc(err || 'Nu a mers de data asta. Încearcă din nou.') + '</p>'); } else showIntro(err); }
  function showResult(left) {
    body('<div class="mst__photo mst__photo--res"><img src="' + resultURL + '" alt="Tu, purtând ' + esc(C.title) + '" data-res>' +
      '<button type="button" class="mst__hold" data-hold>Ține apăsat pentru poza ta</button><span class="mst__tag">Imagine generată cu AI · orientativă</span></div>' +
      '<div class="mst__szbox" data-sizebox></div>' +
      '<div class="mst__pick"><button type="button" class="mst__btn" data-share>' + ICO.share + 'Salvează / trimite</button></div>' +
      '<p class="mst__fine"><button type="button" class="mst__link" data-again>Încearcă altă poză</button>' + (left != null ? ' · Mai ai ' + left + (left === 1 ? ' probă' : ' probe') + ' azi.' : '') + '</p>');
    var img = el.querySelector('[data-res]'), hold = el.querySelector('[data-hold]');
    var show = function () { img.src = fileURL; }, back = function () { img.src = resultURL; };
    ['pointerdown'].forEach(function (ev) { hold.addEventListener(ev, show); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { hold.addEventListener(ev, back); });
    hold.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    renderSizeBox();
    el.querySelector('[data-share]').addEventListener('click', share);
    el.querySelector('[data-again]').addEventListener('click', function () { resultURL = ''; file = null; showIntro(); });
  }
  // mărimea, direct sub imaginea probei
  var autoAsked = false;
  function recVariant(p) {
    var vs = p.variants || [], oi = sizeIdx(p), cur = variantId(), curV = null;
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(cur)) curV = vs[i];
    for (var k = 0; k < vs.length; k++) {
      var v = vs[k], ok = v.options[oi] === rec.size;
      if (ok && curV) for (var j = 0; j < v.options.length; j++) if (j !== oi && v.options[j] !== curV.options[j]) ok = false;
      if (ok) return v;
    }
    return null;
  }
  function renderSizeBox() {
    var box = el.querySelector('[data-sizebox]'); if (!box) return;
    loadProduct().then(function (p) {
      box = el.querySelector('[data-sizebox]'); if (!box) return;
      var vs = p.variants || [];
      if (vs.length <= 1) {
        box.innerHTML = '<button type="button" class="mst__btn mst__btn--pri" data-one>Adaugă în coș</button>';
        box.querySelector('[data-one]').addEventListener('click', function () { addToCart(vs[0], null); });
        return;
      }
      if (rec) {
        var rv = recVariant(p), okAv = rv && rv.available;
        box.innerHTML = '<div class="mst__rec mst__rec--res"><span class="mst__rec-k">' + ICO.spark + 'Mărimea recomandată</span><b>' + esc(rec.size) + '</b>' +
          (okAv ? '<button type="button" class="mst__rec-go" data-recadd>Adaugă în coș · ' + esc(rec.size) + '</button>'
                : '<p class="mst__err">Mărimea ' + esc(rec.size) + ' e epuizată acum.</p>') +
          '<button type="button" class="mst__link" data-other>Altă mărime</button></div>';
        var ra = box.querySelector('[data-recadd]'); if (ra) ra.addEventListener('click', function () { addToCart(rv, p); });
        box.querySelector('[data-other]').addEventListener('click', pickSize);
        return;
      }
      var b = bodyData();
      box.innerHTML = '<form class="mst__fit mst__fit--res" data-fitform><p class="mst__lead">Ce mărime îți vine? Află în 5 secunde:</p>' +
        '<div class="mst__row mst__row--3"><label>Înălțime<input type="number" inputmode="numeric" name="hcm" min="130" max="215" placeholder="cm" value="' + esc(b.h || '') + '" required></label>' +
        '<label>Greutate<input type="number" inputmode="numeric" name="wkg" min="35" max="220" placeholder="kg" value="' + esc(b.w || '') + '" required></label>' +
        '<button type="submit" class="mst__rec-go mst__rec-go--sm">Află mărimea</button></div>' +
        '<input type="hidden" name="usual" value="' + esc(b.u || '') + '"><input type="hidden" name="fit" value="' + esc(b.f || 'normal') + '">' +
        '<button type="button" class="mst__link" data-other>Aleg singur mărimea</button></form>';
      var ff = box.querySelector('[data-fitform]');
      ff.addEventListener('submit', function (ev) { ev.preventDefault(); askSize(ff, renderSizeBox); });
      box.querySelector('[data-other]').addEventListener('click', pickSize);
      // datele salvate → calculăm singuri
      if (b.h && b.w && !autoAsked) { autoAsked = true; askSize(ff, renderSizeBox); }
    }).catch(function () {});
  }

  // ─── alegerea mărimii înainte de coș ───
  var prodJS = null;
  function loadProduct() {
    if (prodJS) return Promise.resolve(prodJS);
    return fetch('/products/' + encodeURIComponent(C.handle) + '.js').then(function (r) { return r.json(); }).then(function (p) { prodJS = p; return p; });
  }
  function addToCart(v, p) {
    if (APP) { toApp(v, p, !!resultURL); return; } // _proba_virtuala doar dacă a existat o probă reușită
    var form = pvForm();
    if (rec && form) {
      setProp('_marime_recomandata', rec.size);
      if (v && p && v.options[p.options.length > 1 ? sizeIdx(p) : 0] === rec.size) track('cart_rec');
    }
    if (v && p) {
      var oi = p.options.length > 1 ? sizeIdx(p) : 0, oname = (p.options[oi] && p.options[oi].name) || '', val = v.options[oi];
      var radios = document.querySelectorAll('.product-details variant-picker input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (nmOk(radios[i], oname) && radios[i].value === val) {
          var lab = document.querySelector('.product-details label[for="' + radios[i].id + '"]');
          (lab || radios[i]).click(); break;
        }
      }
    }
    close(); track('cart');
    setTimeout(function () {
      var idIn = form && form.querySelector('[name="id"]');
      if (v && idIn && String(idIn.value) !== String(v.id)) idIn.value = v.id;
      var atc = document.querySelector('.product-details .add-to-cart-button');
      if (atc) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { atc.click(); }, 250); }
    }, 300);
  }
  function sizeIdx(p) {
    for (var i = 0; i < p.options.length; i++) if (/m[ăa]rim|m[ăa]sur|size|talie|num[ăa]r/i.test(p.options[i].name || '')) return i;
    return p.options.length - 1;
  }
  var rec = null, mode = 'try';
  var APP = /[?&]app=1\b/.test(location.search);
  function toApp(v, p, tried) {
    if (!v) return;
    if (rec && p) { var oi = p.options.length > 1 ? sizeIdx(p) : 0; if (v.options[oi] === rec.size) track('cart_rec'); }
    track('cart');
    var q = 'v=' + v.id + (tried ? '&try=1' : '') + (rec ? '&rec=' + encodeURIComponent(rec.size) : '');
    setTimeout(function () { location.href = 'militaryshop://proba?' + q; }, 150);
  }
  function bodyData() { try { return JSON.parse(localStorage.getItem('mst_body') || '{}') || {}; } catch (e) { return {}; } }
  function pickSize() {
    loadProduct().then(function (p) {
      var vs = p.variants || [];
      if (vs.length <= 1) { addToCart(vs[0], null); return; }
      var oi = sizeIdx(p), cur = variantId(), curV = null;
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(cur)) curV = vs[i];
      // celelalte opțiuni (ex. culoarea) rămân cele alese pe pagină
      var list = vs.filter(function (v) {
        if (!curV) return true;
        for (var j = 0; j < v.options.length; j++) if (j !== oi && v.options[j] !== curV.options[j]) return false;
        return true;
      });
      var oname = (p.options[oi] && p.options[oi].name) || 'Mărime';
      var h = (mode === 'size' || !resultURL) ? '<p class="mst__lead mst__lead--size">Îți calculăm mărimea potrivită din înălțime și greutate.</p>' : '<div class="mst__photo mst__photo--mini"><img src="' + resultURL + '" alt=""></div>';
      if (rec) {
        var CONF = { high: 'mare', medium: 'medie', low: 'mică' };
        h += '<div class="mst__rec"><span class="mst__rec-k">' + ICO.spark + 'Mărimea recomandată</span>' +
          '<b>' + esc(rec.size) + '</b>' + (rec.alt ? '<small>sau ' + esc(rec.alt) + '</small>' : '') +
          (rec.reason ? '<p>' + esc(rec.reason) + '</p>' : '') +
                    (rec.available
            ? '<button type="button" class="mst__rec-go" data-recgo>' + 'Adaugă în coș · ' + esc(rec.size) + '</button>'
            : '<p class="mst__err">Mărimea recomandată e epuizată acum' + (rec.alt ? '. Poți alege ' + esc(rec.alt) + ' mai jos.' : '.') + '</p>') +
          '<button type="button" class="mst__link" data-redo>Schimbă datele</button></div>';
      } else {
        var b = bodyData();
        h += '<form class="mst__fit" data-fitform><p class="mst__lead">Nu știi ce mărime să alegi? Îți recomandăm noi:</p>' +
          '<div class="mst__row"><label>Înălțime<input type="number" inputmode="numeric" name="hcm" min="130" max="215" placeholder="cm" value="' + esc(b.h || '') + '" required></label>' +
          '<label>Greutate<input type="number" inputmode="numeric" name="wkg" min="35" max="220" placeholder="kg" value="' + esc(b.w || '') + '" required></label></div>' +
          '<div class="mst__row"><label>Mărimea obișnuită<input type="text" name="usual" maxlength="20" placeholder="opțional, ex. L, 52" value="' + esc(b.u || '') + '"></label>' +
          '<label>Cum să-ți vină<select name="fit"><option value="normal">Normal</option><option value="strans"' + (b.f === 'strans' ? ' selected' : '') + '>Mai pe corp</option><option value="larg"' + (b.f === 'larg' ? ' selected' : '') + '>Mai larg</option></select></label></div>' +
          '<button type="submit" class="mst__btn">' + ICO.spark + 'Recomandă-mi mărimea</button>' +
          '<p class="mst__fine">Înălțimea și greutatea rămân doar în telefonul tău.</p></form>';
      }
      h += '<p class="mst__lead' + (rec ? ' mst__lead--other' : '') + '">' + (rec ? 'Sau alege altă ' + esc(oname.toLowerCase()) + ':' : 'Alege ' + esc(oname.toLowerCase()) + ':') + '</p><div class="mst__sizes' + (rec ? ' mst__sizes--other' : '') + '">';
      list.forEach(function (v) {
        var isRec = rec && v.options[oi] === rec.size;
        h += '<button type="button" class="mst__size' + (isRec ? ' is-rec' : '') + '"' + (v.available ? '' : ' disabled') + ' data-v="' + v.id + '">' +
          (isRec ? '<em>recomandat</em>' : '') + esc(v.options[oi]) + (v.available ? '' : '<small>epuizat</small>') + '</button>';
      });
      h += '</div><p class="mst__fine"><button type="button" class="mst__link" data-back>← Înapoi la probă</button></p>';
      body(h);
      el.querySelectorAll('.mst__size[data-v]').forEach(function (bt) {
        bt.addEventListener('click', function () {
          var id = bt.getAttribute('data-v'), v = null;
          for (var k = 0; k < vs.length; k++) if (String(vs[k].id) === id) v = vs[k];
          addToCart(v, p);
        });
      });
      var bk = el.querySelector('[data-back]');
      if (mode === 'size' || !resultURL) { if (bk) bk.parentNode.remove(); } else bk.addEventListener('click', function () { showResult(); });
      var ff = el.querySelector('[data-fitform]');
      if (ff) ff.addEventListener('submit', function (ev) { ev.preventDefault(); askSize(ff); });
      var rg = el.querySelector('[data-recgo]');
      if (rg) rg.addEventListener('click', function () { var c = el.querySelector('.mst__size.is-rec'); if (c) c.click(); });
      var rd = el.querySelector('[data-redo]');
      if (rd) rd.addEventListener('click', function () { rec = null; pickSize(); });
      var rc = el.querySelector('.mst__size.is-rec');
      var rcard = el.querySelector('.mst__rec'); if (rcard) setTimeout(function () { rcard.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 120);
    }).catch(function () { close(); var s = document.querySelector('.product-details variant-picker'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }
  function openSize() {
    if (!el) build();
    mode = 'size';
    el.classList.add('is-on'); document.documentElement.classList.add('mst-lock');
    pickSize();
  }
  function selectOnPage(v, p) {
    if (APP) { toApp(v, p, !!resultURL); return; }
    var oi = p.options.length > 1 ? sizeIdx(p) : 0, oname = (p.options[oi] && p.options[oi].name) || '', val = v.options[oi];
    var radios = document.querySelectorAll('.product-details variant-picker input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (nmOk(radios[i], oname) && radios[i].value === val) {
        var lab = document.querySelector('.product-details label[for="' + radios[i].id + '"]');
        (lab || radios[i]).click(); break;
      }
    }
    var form = pvForm();
    if (rec && form) {
      setProp('_marime_recomandata', rec.size);
      if (val === rec.size) track('cart_rec');
    }
    close();
    setTimeout(function () {
      var idIn = form && form.querySelector('[name="id"]');
      if (idIn && String(idIn.value) !== String(v.id)) idIn.value = v.id;
      var atc = document.querySelector('.product-details .add-to-cart-button');
      if (atc) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); atc.classList.add('mst-pulse'); setTimeout(function () { atc.classList.remove('mst-pulse'); }, 1800); }
      paintSizeBtn();
    }, 250);
  }
  function paintSizeBtn() {
    var b = document.querySelector('.mst-sizebtn');
    if (!b) return;
    var s = b.querySelector('small');
    if (s) s.textContent = rec ? 'Recomandat pentru tine: ' + rec.size : 'Calculată din înălțime și greutate';
  }
  function nmOk(el, n) { return el.name === n || el.name.indexOf(n + '-') === 0; }
  function mountSizeButton() {
    var ex = document.querySelector('.mst-sizebtn');
    if (ex) {
      if (!ex.dataset.b) { ex.dataset.b = '1'; ex.addEventListener('click', function (e) { e.preventDefault(); openSize(); }); paintSizeBtn(); }
      window.MSTSizeDone = true;
      return;
    }
    loadProduct().then(function (p) {
      if (!p || (p.variants || []).length < 2) return;
      var oi = sizeIdx(p), oname = (p.options[oi] && p.options[oi].name) || '';
      if (!/m[ăa]rim|m[ăa]sur|size|talie|num[ăa]r/i.test(oname) && p.options.length > 1) return;
      var radio = null, rs = document.querySelectorAll('.product-details variant-picker input[type="radio"]');
      for (var i = 0; i < rs.length; i++) if (nmOk(rs[i], oname)) { radio = rs[i]; break; }
      var box = radio ? radio.closest('fieldset, .product-form__input') : document.querySelector('.product-details variant-picker');
      if (!box || document.querySelector('.mst-sizebtn')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mst-sizebtn';
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 15l12-12 6 6-12 12z"/><path d="M7 11l2 2M10 8l2 2M13 5l2 2M5 13l1.5 1.5"/></svg>' +
        '<span><b>Află ce mărime ți se potrivește</b><small>Calculată din înălțime și greutate</small></span>' + ICO.spark;
      b.addEventListener('click', function (e) { e.preventDefault(); openSize(); });
      // în afara selectorului de variante: Horizon îl reface la fiecare alegere, iar butonul nu mai trebuie să dispară/reapară
      var vp = box.closest('variant-picker') || box;
      vp.parentNode.insertBefore(b, vp);
      paintSizeBtn();
    }).catch(function () {}).then(function () { window.MSTSizeDone = true; });
  }
  function askSize(ff, after) {
    var fd = new FormData(ff), btn = ff.querySelector('button[type="submit"]');
    try { localStorage.setItem('mst_body', JSON.stringify({ h: fd.get('hcm'), w: fd.get('wkg'), u: fd.get('usual'), f: fd.get('fit') })); } catch (e) {}
    fd.append('action', 'size'); fd.append('handle', C.handle); fd.append('variant', variantId()); fd.append('d', devId());
    if (file) fd.append('photo', file, 'poza.jpg');
    btn.disabled = true; btn.textContent = 'Calculăm…';
    var fail = function (msg) {
      btn.disabled = false; btn.innerHTML = after ? 'Află mărimea' : ICO.spark + 'Recomandă-mi mărimea';
      var old = ff.querySelector('.mst__err'); if (old) old.remove();
      ff.insertAdjacentHTML('afterbegin', '<p class="mst__err">' + esc(msg || 'Nu a mers. Încearcă din nou.') + '</p>');
    };
    fetch(C.api, { method: 'POST', body: fd, credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (r) { if (r && r.ok) { rec = r; track('size'); aiFlag('_ai_marime', String(r.size || 'da')); (after || pickSize)(); paintSizeBtn(); } else fail(r && r.error); })
      .catch(function () { fail('Conexiunea s-a întrerupt. Încearcă din nou.'); });
  }

  // imaginea cu o bandă discretă jos: „Probă virtuală · military-shop.ro”
  function share() {
    var im = new Image();
    im.onload = function () {
      var c = document.createElement('canvas'), w = im.naturalWidth, h = im.naturalHeight, bh = Math.round(w * 0.07);
      c.width = w; c.height = h + bh; var x = c.getContext('2d');
      x.drawImage(im, 0, 0); x.fillStyle = '#1d3a27'; x.fillRect(0, h, w, bh);
      x.fillStyle = '#fec610'; x.font = '700 ' + Math.round(bh * 0.42) + 'px system-ui, sans-serif'; x.textBaseline = 'middle';
      x.fillText('MILITARY SHOP', Math.round(bh * 0.4), h + bh / 2);
      x.fillStyle = '#fff'; x.font = '500 ' + Math.round(bh * 0.34) + 'px system-ui, sans-serif'; x.textAlign = 'right';
      x.fillText('Probă virtuală · military-shop.ro', w - Math.round(bh * 0.4), h + bh / 2);
      c.toBlob(function (b) {
        var f = new File([b], 'proba-military-shop.jpg', { type: 'image/jpeg' });
        if (navigator.canShare && navigator.canShare({ files: [f] })) {
          navigator.share({ files: [f], title: C.title, text: 'Cum îmi stă? ' + location.origin + '/products/' + C.handle }).catch(function () {});
        } else {
          var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = 'proba-military-shop.jpg'; document.body.appendChild(a); a.click(); a.remove();
        }
        track('share');
      }, 'image/jpeg', 0.9);
    };
    im.src = resultURL;
  }
  function track(what) {
    try { if (window.gtag) gtag('event', 'try_on_' + what, { item_name: C.title }); } catch (e) {}
    try {
      var fd = new FormData(); fd.append('action', 'ev'); fd.append('e', what); fd.append('d', devId()); fd.append('h', C.handle);
      if (!(navigator.sendBeacon && navigator.sendBeacon(C.api, fd))) fetch(C.api, { method: 'POST', body: fd, credentials: 'omit', keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  // după o probă reușită, produsul pus în coș (din fereastră sau cu butonul normal) poartă eticheta ascunsă _proba_virtuala → o vedem în comenzi
  // eticheta pe COȘ (nu pe produs): clientul a folosit proba / mărimea → trece pe comandă, orice ar cumpăra
  function aiFlag(k, v) {
    if (APP) return;
    var a = {}; a[k] = v;
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ attributes: a }) }).catch(function () {}); } catch (e) {}
  }
  function markForm() {
    var form = pvForm();
    setProp('_proba_virtuala', 'da');
    aiFlag('_ai_proba', 'da');
    try { sessionStorage.setItem('mst_ok_' + C.handle, '1'); } catch (e) {}
  }

  window.MSTryOn = { open: open, size: function () { openSize(); } };
  function boot() {
    try { if (sessionStorage.getItem('mst_ok_' + C.handle)) setTimeout(markForm, 800); } catch (e) {}
    mountButton();
    setTimeout(mountButton, 1500);
    if (kind !== 'bag' && kind !== 'eyes') { mountSizeButton(); setTimeout(mountSizeButton, 1600); } else window.MSTSizeDone = true;
    // Horizon reface selectorul de variante (morph) la fiecare alegere de mărime/culoare: remontăm butoanele dacă au dispărut
    // galeria: o punem la loc imediat (în același cadru, înainte de afișare), deci butonul de pe poză nu mai clipește
    var media = document.querySelector('.product-information__media');
    if (media && window.MutationObserver) {
      new MutationObserver(function () { if (!document.querySelector('.mst-open')) mountButton(); })
        .observe(media, { childList: true, subtree: true });
    }
    var pd = document.querySelector('.product-details');
    if (pd && window.MutationObserver) {
      var mt;
      new MutationObserver(function () {
        clearTimeout(mt);
        mt = setTimeout(function () {
          if (kind !== 'bag' && kind !== 'eyes' && !document.querySelector('.mst-sizebtn')) mountSizeButton();
          mountButton();
        }, 120);
      }).observe(pd, { childList: true, subtree: true });
    }
    if (/[?&]proba=1\b/.test(location.search)) setTimeout(open, 400);
    else if (/[?&]marime=1\b/.test(location.search)) setTimeout(function () { if (window.MSTryOn) MSTryOn.size(); }, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* msd: pornește strălucirea butonului „Probă” abia la prima interacțiune */
(function(){var ev=['scroll','pointerdown','touchstart','keydown'];function go(){ev.forEach(function(e){window.removeEventListener(e,go,true)});document.documentElement.classList.add('mst-glow-on')}ev.forEach(function(e){window.addEventListener(e,go,{capture:true,passive:true})})})();
